<template>
  <div>
    <b-badge
      v-if="step === flowStates.PROCESSING"
      variant="light-warning"
      class="mr-3"
    >
      Procesando
    </b-badge>
    <b-avatar
      v-if="step === flowStates.PROCESSING"
      rounded
      v-b-tooltip="'Procesando'"
      size="28"
      variant="light-warning"
    >
      <feather-icon
        size="18"
        icon="LoaderIcon"
      />
    </b-avatar>
    <b-badge
      v-if="step === flowStates.PENDING"
      variant="light-secondary"
      class="mr-3"
    >
      Pendiente
    </b-badge>
    <b-avatar
      v-if="step === flowStates.PENDING"
      rounded
      v-b-tooltip="'Pendiente'"
      size="28"
      variant="light-secondary"
    >
      <feather-icon
        size="18"
        icon="AlertCircleIcon"
      />
    </b-avatar>
    <b-badge
      v-if="step === flowStates.APPROVED"
      variant="light-success"
      class="mr-3"
    >
      Aprobado
    </b-badge>
    <b-avatar
      v-if="step === flowStates.APPROVED"
      rounded
      v-b-tooltip="'Aprobado'"
      size="28"
      variant="light-success"
    >
      <feather-icon
        size="18"
        icon="ThumbsUpIcon"
      />
    </b-avatar>
    <b-badge
      v-if="step === flowStates.REJECTED"
      variant="light-danger"
      class="mr-3"
    >
      Rechazado
    </b-badge>
    <b-avatar
      v-if="step === flowStates.REJECTED"
      rounded
      v-b-tooltip="'Rechazado'"
      size="28"
      variant="light-danger"
    >
      <feather-icon
        size="18"
        icon="ThumbsDownIcon"
      />
    </b-avatar>
    <b-badge
      v-if="step === flowStates.FORWARDED"
      variant="light-info"
      class="mr-3"
    >
      Reenviado
    </b-badge>
    <b-avatar
      v-if="step === flowStates.FORWARDED"
      rounded
      v-b-tooltip="'Reenviado'"
      size="28"
      variant="light-info"
    >
      <feather-icon
        size="18"
        icon="ShuffleIcon"
      />
    </b-avatar>
    <b-badge
      v-if="step === flowStates.RETURNED"
      variant="light-info"
      class="mr-3"
    >
      Devuelto
    </b-badge>
    <b-avatar
      v-if="step === flowStates.RETURNED"
      rounded
      v-b-tooltip="'Devuelto'"
      size="28"
      variant="light-info"
    >
      <feather-icon
        size="18"
        icon="CornerUpLeftIcon"
      />
    </b-avatar>
  </div>
</template>
<script>
import ApprovalProcessStates from '@/febos/chile/approvals/mixins/ApprovalProcessStates';

export default {
  props: {
    step: { type: String, required: true }
  },
  data() {
    return {
      flowStates: ApprovalProcessStates
    };
  }
};
</script>
